import { useTranslation } from "react-i18next";
import { Outlet, useLocation } from "react-router";
import { isAllowed } from "../../api/access/decisions";
import { useSession } from "../../session/sessionContext";
import { sessionDecision } from "../../session/sessionMachine";
import { useTabTitle } from "../../shell/workspace";
import BlockedState from "../../ui/feedback/BlockedState";
import StatusMessage from "../../ui/feedback/StatusMessage";
import PageNav from "../../ui/navigation/PageNav";
import { ADMINISTRATION_PAGES, administrationPageOf } from "./administrationPages";

/**
 * Administration (web-app.md WA-8): what the installation sets, as GitHub's and GitLab's admin
 * areas: accounts and inviting to DMW, server keys, the installation's settings with the
 * defaults for new projects, its groups, its ResearchSpace (F5), and the deleted projects
 * (F121). Anyone holding one of their installation permissions comes in; a page whose
 * permission they lack shows unavailable, with why, and opened by its address shows
 * BlockedState in its place (accounts.md GS-2, GS-8).
 */
export default function AdministrationLayout() {
  const { t } = useTranslation();
  const { session } = useSession();
  const { pathname } = useLocation();
  const pages = ADMINISTRATION_PAGES.map((page) => ({ page, decision: sessionDecision(session, page.action) }));
  const current = pages.find(({ page }) => page === administrationPageOf(pathname));
  // The tab names the area, not the section it opened from (IM-SHELL, C6).
  useTabTitle({ kind: "other", name: t("administration.title") });
  // Without any installation permission Administration stays closed (redesign R3-5).
  if (!pages.some(({ decision }) => isAllowed(decision))) {
    return (
      <div className="p-6">
        <StatusMessage tone="info">{t("administration.onlyAdministrators")}</StatusMessage>
      </div>
    );
  }
  return (
    <div className="app-main h-full space-y-5 p-6">
      <PageNav label={t("administration.title")} pages={pages.map(({ page, decision }) => ({ path: page.path, label: t(page.labelKey), requires: decision }))} />
      {/* The area's widest page, as a project's settings have it; a page may keep to less. */}
      <div className="max-w-6xl">
        {current === undefined ? <Outlet /> : <BlockedState decision={current.decision}><Outlet /></BlockedState>}
      </div>
    </div>
  );
}
